// extracted by mini-css-extract-plugin
export var divider = "_jp-7";
export var itemsToggle = "_jp-8";
export var mergeModal = "_jp-1";
export var optionCard = "_jp-4";
export var radioGroup = "_jp-6";
export var radioOption = "_jp-0";
export var selected = "_jp-5";
export var shipmentOptions = "_jp-2";
export var tableOptions = "_jp-3";